import {
  errorMessageGA,
  paymentCompleteGA,
  paymentErrorGA,
  searchFormSubmitGA,
  searchResultsFilteringGA,
} from '../../analytics';
import { COMPLETE_BOOKING } from '../booking/booking/action-types';
import {
  bookingChannelIdSelector,
  bookingIdSelector,
  bookingParkSelector,
  discountValueSelector,
  partyBookingSelector,
  unitTypeIdSelector,
} from '../booking/booking/selectors';
import { paymentAmountSelector, selectedExtrasWithValuesSelector } from '../booking/form/selectors';
import { POST_PAYMENT } from '../booking/payment/action-types';
import { paymntUsedSelector, postPaymentErrorDataSelector } from '../booking/payment/selectors';
import { FAILURE } from '../constants';
import { TOGGLE_OFFER } from '../offers/action-types';
import { allOffersDataSelector, selectedOffersUrnsSelector } from '../offers/selectors';
import { START_SEARCH } from '../search/form/action-types';

export const analyticsMiddleware = (store) => (next) => (action) => {
  if (!action || !action.type) {
    return next(action);
  }
  if (action.type.endsWith(FAILURE)) {
    errorMessageGA(action.payload.errors?.message);
  }
  switch (action.type) {
    case TOGGLE_OFFER: {
      const state = store.getState();
      const selectedOffersUrns = selectedOffersUrnsSelector(state);
      const allOffers = allOffersDataSelector(state);
      const stringUrn = action.payload.toString();

      const offerName = allOffers.find(({ urn }) => urn === stringUrn).offer;
      const isSelected = selectedOffersUrns.includes(stringUrn);

      if (offerName) searchResultsFilteringGA(offerName, isSelected, 'Offer');
      break;
    }
    case START_SEARCH: {
      searchFormSubmitGA(action.payload);
      break;
    }
    case COMPLETE_BOOKING: {
      const state = store.getState();
      const paymentAmount = paymentAmountSelector(state);
      const bookingId = bookingIdSelector(state);
      const channelId = bookingChannelIdSelector(state);
      const park = bookingParkSelector(state);
      const extras = selectedExtrasWithValuesSelector(state);
      const partyBooking = partyBookingSelector(state);
      const unitTypeId = unitTypeIdSelector(state);
      const discount = discountValueSelector(state);
      const paymentUsed = paymntUsedSelector(state);

      paymentCompleteGA(bookingId, paymentAmount, unitTypeId, park, channelId, extras, partyBooking, discount, paymentUsed);
      break;
    }
    case POST_PAYMENT + FAILURE: {
      const state = store.getState();
      const error = postPaymentErrorDataSelector(state);
      paymentErrorGA(error?.message, error?.status);
      break;
    }
    default:
      break;
  }

  return next(action);
};
